import { Group } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconPlus } from "@tabler/icons-react"
import {
  SortingState,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table"
import { Button } from "@tfg/ui"
import { useState } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"
import {
  standardsCreateSchema,
  standardsCreateValidationType,
} from "@tfg/types/schemas/admin"

import { Table } from "~/components/table/Table"
import { FormFieldConfig } from "~/pages/Admin/components/TypesForm"

import { DrawerForm } from "../DrawerForm"

import { useColumns } from "./columns"
import { useCreateStandardMutation } from "./hooks"

type Props = {
  standards: AdminResponses.Standards[]
  certificatesTypesList: AdminResponses.CertificateTypeList[]
}

export function Standards({ standards, certificatesTypesList }: Props) {
  const [sorting, setSorting] = useState<SortingState>([
    { id: "name", desc: false },
  ])
  const [drawerOpen, drawerActions] = useDisclosure(false)
  const { mutate: createStandard } = useCreateStandardMutation({
    onSuccess: drawerActions.close,
  })

  const columns = useColumns(certificatesTypesList)
  const table = useReactTable({
    data: standards,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  const formattedOptions = certificatesTypesList.map((option) => ({
    value: option.id.toString(),
    label: option.key,
  }))
  const fields: FormFieldConfig[] = [
    {
      type: "text",
      name: "name",
      label: "Name",
      placeholder: "Name",
    },
    {
      type: "multiselect",
      name: "certificateTypes",
      label: "Certificates",
      placeholder: "Certificates",
      options: formattedOptions,
    },
  ]

  return (
    <>
      <Group justify="right" mt="sm">
        <Button onClick={() => drawerActions.open()} icon={<IconPlus />}>
          New Standard
        </Button>
      </Group>
      {drawerOpen ? (
        <DrawerForm<standardsCreateValidationType>
          drawerActions={drawerActions}
          schema={standardsCreateSchema}
          initialValues={{
            name: "",
            certificateTypes: [],
          }}
          mutate={createStandard}
          fields={fields}
        />
      ) : null}
      <Table table={table} pagination={false} />
    </>
  )
}
